import { memo } from 'react';

import { useAdsColorsStyles } from '~/hooks/useAdsColorsStyles';

export const AdsColorsStylesListener = memo(() => {
  useAdsColorsStyles();

  return null;
});

AdsColorsStylesListener.displayName = 'AdsColorsStylesListener';
